import { getStayRequest, getExchangeConfig, updateStayRequestDates, changeStayRequestToReciprocal, changeStayRequestToNonReciprocal, preapproveExchange, cancelPreApprobation, createStayRequestV3 as baseCreateStayRequestV3 } from '@homeexchange/conversations';
import { exchangeUpdated, exchangeUpdateFailed, fetchConversation } from './conversations';
import { handleUnauthorized } from './auth';
export var RECEIVE_STAY_REQUEST_CONFIG = 'RECEIVE_STAY_REQUEST_CONFIG';
export var REQUEST_STAY_REQUEST_FOR_CONVERSATION = 'REQUEST_STAY_REQUEST_FOR_CONVERSATION';
export var RECEIVE_STAY_REQUEST_FOR_CONVERSATION = 'RECEIVE_STAY_REQUEST_FOR_CONVERSATION';
export var REQUEST_FINISH_STAY_REQUESTS_FOR_CONVERSATION = 'REQUEST_FINISH_STAY_REQUESTS_FOR_CONVERSATION';
export function receiveStayRequestConfig(response) {
    return {
        type: RECEIVE_STAY_REQUEST_CONFIG,
        nbDaysPreapprobationExpiration: response.NB_DAYS_PREAPPROVAL_EXPIRATION,
        nbDaysToAutoDecline: response.NB_DAYS_TO_AUTO_DECLINE
    };
}
export function fetchStayRequestConfig() {
    return function (dispatch) {
        return handleUnauthorized(dispatch, function () {
            return getExchangeConfig();
        }).then(function (response) {
            dispatch(receiveStayRequestConfig(response));
        });
    };
}
export function requestStayRequestForConversation(id) {
    return {
        type: REQUEST_STAY_REQUEST_FOR_CONVERSATION,
        id: id
    };
}
export function receiveStayRequestForConversation(response, id) {
    return {
        type: RECEIVE_STAY_REQUEST_FOR_CONVERSATION,
        stayRequest: response,
        id: id
    };
}
export function requestFinishStayRequestForConversation(id) {
    return {
        type: REQUEST_FINISH_STAY_REQUESTS_FOR_CONVERSATION,
        id: id
    };
}
export function fetchStayRequestForConversation(conversation) {
    return function (dispatch) {
        if (!conversation) {
            return;
        }
        dispatch(requestStayRequestForConversation(conversation.id));
        return handleUnauthorized(dispatch, function () {
            return getStayRequest(conversation.id);
        })
            .then(function (response) {
            dispatch(receiveStayRequestForConversation(response, conversation.id));
        })
            .finally(function () { return dispatch(requestFinishStayRequestForConversation(conversation.id)); });
    };
}
export function updateDatesForConversation(conversationId, exchangeId, startOn, endOn) {
    return function (dispatch) {
        return handleUnauthorized(dispatch, function () {
            return updateStayRequestDates(conversationId, { exchangeId: exchangeId, startOn: startOn, endOn: endOn });
        })
            .then(function (response) {
            dispatch(exchangeUpdated(response));
        })
            .catch(function (response) {
            dispatch(exchangeUpdateFailed(response));
            throw response;
        });
    };
}
export function updateStayRequestToReciprocal(conversationId, guestHomeId) {
    return function (dispatch, getState) {
        var conversation = getState().conversations.conversations.find(function (_a) {
            var id = _a.id;
            return id === conversationId;
        });
        return handleUnauthorized(dispatch, function () {
            return changeStayRequestToReciprocal(conversationId, guestHomeId);
        })
            .then(function () {
            dispatch(fetchConversation(conversationId));
            dispatch(fetchStayRequestForConversation(conversation));
        })
            .catch(function (response) { return dispatch(exchangeUpdateFailed(response)); });
    };
}
export function updateStayRequestToNonReciprocal(conversationId, exchangeIdToDelete) {
    return function (dispatch, getState) {
        var conversation = getState().conversations.conversations.find(function (_a) {
            var id = _a.id;
            return id === conversationId;
        });
        return handleUnauthorized(dispatch, function () {
            return changeStayRequestToNonReciprocal(conversationId, exchangeIdToDelete);
        })
            .then(function () {
            dispatch(fetchConversation(conversationId));
            dispatch(fetchStayRequestForConversation(conversation));
        })
            .catch(function (response) { return dispatch(exchangeUpdateFailed(response)); });
    };
}
export function preapproveStayRequest(conversationId) {
    return function (dispatch) {
        return handleUnauthorized(dispatch, function () {
            return preapproveExchange(conversationId);
        });
    };
}
export function cancelStayRequest(conversationId) {
    return function (dispatch) {
        return handleUnauthorized(dispatch, function () {
            return cancelPreApprobation(conversationId);
        });
    };
}
export function createStayRequestV3(data) {
    return function (dispatch) {
        return handleUnauthorized(dispatch, function () {
            return baseCreateStayRequestV3(data);
        });
    };
}
